// Öğrenci adını, varsa veli(ler)inin adı parantez içinde olacak şekilde biçimlendirir.
// Örn: "Ahmet Mehmet (Fatma Hn.)"
export const formatStudentLabel = (student) => {
  if (!student) return '';
  const base = `${student.name || ''} ${student.surname || ''}`.trim();
  const parents = student.parents || [];
  if (parents.length === 0) return base;
  const parentNames = parents.map(p => `${p.name || ''} ${p.surname || ''}`.trim()).join(', ');
  return `${base} (${parentNames})`;
};
